import React, { Component } from 'react';
import { Card, Divider, Table, Tag } from 'antd';
import DescriptionList from '@comm/DescriptionList';

import moment from 'moment';
import { queryFilePreview } from '@api/pub/attachment';

const { Description } = DescriptionList;

class CardInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    return [
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '附件',
        dataIndex: 'uuid',
        key: 'uuid',
        render: (text, record) => {
          return (
            <div>
              {(record.files || []).map(item => {
                return (
                  <a
                    key={item.uuid}
                    style={{ display: 'block' }}
                    onClick={() => queryFilePreview(item)}
                  >
                    {item.name}
                  </a>
                );
              })}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { data } = this.props;
    return (
      <Card>
        <DescriptionList size="large" col={3}>
          <Description term="任务名称">{data.name}</Description>
          <Description term="任务周期">
            {data.beginDate ? moment(data.beginDate).format('YYYY-MM-DD') : ''}至
            {data.endDate ? moment(data.endDate).format('YYYY-MM-DD') : '永久'}
          </Description>
          <Description term="任务分类">
            {data.type === 0 ? <span>绩效考核</span> : ''}
            {data.type === 1 ? <span>政府申报</span> : ''}
            {data.type === 2 ? <span>日常任务</span> : ''}
          </Description>
          <Description term="业务部门">{data.workorgName}</Description>
          <Description term="任务标签">
            {(data.tags || []).map(item => {
              return <Tag key={item}>{item}</Tag>;
            })}
          </Description>
        </DescriptionList>

        <Divider />

        <DescriptionList size="large" col={2}>
          <Description term="任务执行方式">{data.isReview ? '需要审核' : '无需审核'}</Description>
        </DescriptionList>

        <DescriptionList size="large" col={3}>
          <Description term="任务负责人">
            {data.executives ? data.executives[0].userName : ''}
          </Description>
          <Description term="任务协助人">
            {(data.assistants || []).map(item => {
              return (
                <span key={item.uuid} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                  {item.userName}
                </span>
              );
            })}
          </Description>
          {data.isReview ? (
            <Description term="任务审批人">
              {(data.reviewers || []).map(item => {
                return (
                  <span key={item.uuid} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    {item.userName}
                  </span>
                );
              })}
            </Description>
          ) : null}
        </DescriptionList>

        <Divider />
        <DescriptionList size="large">
          <Description term="任务目标" col={1}>
            {data.aim}
          </Description>
        </DescriptionList>
        <DescriptionList size="large">
          <Description term="任务描述" col={1}>
            {data.remark}
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="任务模板">
            <Table
              rowKey="uuid"
              pagination={false}
              columns={this.columns()}
              dataSource={data.taskFiles}
            />
          </Description>
        </DescriptionList>
      </Card>
    );
  }
}

export default CardInfo;



// WEBPACK FOOTER //
// ./src/components/task/spTask/pageDetail/CardTaskInfo.js